import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import React, { useContext, useState } from 'react'
import MatchSquares, { _msTypes } from '../matches/MatchSquares'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { Button, Modal, Popup } from 'semantic-ui-react'

const text = `
<p>
  If you want to <span class="highlight score">report a score through Thumbstat</span>, first find the <span class="highlight score">match</span> you want to update. Then <span class="highlight score score">long press</span> on that match (not just a simple click). A window will open where you can <span class="highlight score">submit</span> the score—quick and easy.
</p>

<p>
  Then click on <span class="highlight score">Match Results</span>.
</p>

<p>
  You will be then asked to select the type of match results you would like to enter (<span class="highlight score">Match Scores</span> or <span class="highlight score">Set Scores</span>).
</p>

<p>
  After that, <span class="highlight score">follow the prompts</span>.
</p>

<p>
  Your results submission <span class="highlight score">will</span> show up in the <span class="highlight score">match results</span>, but will <span class="highlight score">not</span> be reflected in the <span class="highlight score">standings</span> until the results are <span class="highlight score">confirmed</span> by Thumbstat.
</p>
`

const mdl = ({ handleClose }) => {
  return <Modal
    size={'mini'}
    open={true}
    onClose={() => handleClose({ type: 'close' })}
    className={'mdl app-dark-mode'}
  >
    <Modal.Header>Score Reporting</Modal.Header>
    <Modal.Content >
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
        <div>Email:</div>
        <div
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const email = 'thumbstatsports@gmail.com';
            window.open(
              `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`,
              '_blank'
            );
          }}
        >
          thumbstatsports@gmail.com
        </div>
      </div>
    </Modal.Content>
    <Modal.Content >
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
        <div>App:</div>
        <div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </Modal.Content>
    <Modal.Actions>
      <Button color='blue' size='tiny' onClick={() => handleClose({ type: 'close' })}>
        OK
      </Button>
    </Modal.Actions>
  </Modal>
}

export const GotScore = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info } = sportsSeason_state ?? {}
  const { matches_combined } = matches_info ?? {}

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const filterMatchesNoResultPastOrToday = (matches) => {
    if (!matches) return {};

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return _.pickBy(matches, (match) => {
      // ❌ Exclude if result exists
      if (_.has(match, 'result') && match.result) return false;

      // ❌ Exclude if no valid startDate
      if (!match?.startDate) return false;

      const parts = match.startDate.split('/');
      if (parts.length !== 3) return false;

      const [month, day, year] = parts;
      const matchDate = new Date(year, month - 1, day);

      // ❌ Invalid date
      if (isNaN(matchDate)) return false;

      // ✅ Include if today or past
      return matchDate <= today;
    });
  };

  const filteredMatches_all = _.pickBy(matches_combined, (match) => !match?.results);

  const filteredMatches_missing = filterMatchesNoResultPastOrToday(matches_combined)

  const [showText, setShowText] = useState()

  const handleShowText = () => setShowText(!showText)

  const content = () => <Wrapper
    content={<div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  ></Wrapper>

  const fpw = () => <FullPageWrapper
    topperCaption='Score Reporting'
    content={content()}
    handleCancel={handleShowText}
    css={{ container: 'app-dark-mode' }}
  ></FullPageWrapper>

  return (
    showText ? mdl({ handleClose: handleShowText }) :
      <div
        className='got-score'
        onClick={() => handleShowText()}
      >
        {'Score to report?'}
      </div>
  )
}
